import styled from 'styled-components';

export const PaginationSC = styled.div`
  display: inline-flex;
  align-items: center;

  .ui-select {
    width: 94px;
  }

  .rc-pagination {
    margin: 0;
    padding: 0;
    ${({ theme }) => theme.mappedTypography.buttonText.default};

    .rc-pagination-disabled {
      opacity: 0.5;
    }

    .rc-pagination-item {
      display: inline-flex;
      align-items: center;
      justify-content: center;

      min-width: 32px;
      min-height: 32px;
      border-radius: ${({ theme }) => theme.radius.small}px;
      border: none;

      background-color: ${({ theme }) => theme.color.surface.secondary};
      color: ${({ theme }) => theme.color.tint.action};

      &:hover {
        background-color: ${({ theme }) =>
          theme.createOverlayColor(theme.color.surface.secondary, 'hover', 'light')};
        &,
        a {
          color: ${({ theme }) =>
            theme.createOverlayColor(theme.color.tint.action, 'hover', 'light')};
        }
      }

      &:focus {
        background-color: ${({ theme }) =>
          theme.createOverlayColor(theme.color.surface.secondary, 'focused', 'light')};
        &,
        a {
          color: ${({ theme }) =>
            theme.createOverlayColor(theme.color.tint.action, 'focused', 'light')};
        }
      }

      &.rc-pagination-item-active {
        border: none;

        &,
        a {
          background-color: ${({ theme }) => theme.color.state.active};
          color: ${({ theme }) => theme.color.tint.onSolid};
        }

        &:hover {
          background-color: ${({ theme }) =>
            theme.createOverlayColor(theme.color.state.active, 'hover', 'light')};
          &,
          a {
            color: ${({ theme }) =>
              theme.createOverlayColor(theme.color.tint.onSolid, 'hover', 'light')};
          }
        }

        &:focus {
          background-color: ${({ theme }) =>
            theme.createOverlayColor(theme.color.state.active, 'focused', 'light')};
          &,
          a {
            color: ${({ theme }) =>
              theme.createOverlayColor(theme.color.tint.onSolid, 'focused', 'light')};
          }
        }
      }
    }

    .rc-pagination-prev,
    .rc-pagination-next {
      display: inline-flex;
      align-items: center;
      justify-content: center;

      min-width: 32px;
      min-height: 32px;
      border-radius: ${({ theme }) => theme.radius.small}px;
      border: none;

      .rc-pagination-item-link {
        border: none;
      }
    }
  }
`;
